<template>
  <div class="container taskAudit" v-loading="loading" element-loading-text="拼命加载中">
    <el-tabs type="border-card" class="card-tab">
      <el-tab-pane label="筛选">
        <el-form :model="param" :inline="true" label-width="100px" class="formInline" size="mini" :rules="rules">
          <div class="slide-wrap" ref="slideWrap1">
            <el-form-item label="任务编号">
              <el-input v-model="param.taskNo" placeholder="请输入准确的项目编号..." :maxlength="30"></el-input>
            </el-form-item>
            <el-form-item label="任务名称">
              <el-input v-model="param.taskName" placeholder="请输入项目名称..." ></el-input>
            </el-form-item>
            <el-form-item label="任务参与时间" class="duration">
              <el-date-picker
                  v-model="param.during.start"
                  type="date"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="任务开始时间"
                  style="width: 45%;float: left;display: inline-block"
              >
                <!--value-format="yyyy-MM-dd"-->
              </el-date-picker>
              <span style="display:inline-block;width: 10%;text-align: center;float: left">—</span>
              <el-date-picker
                  v-model="param.during.end"
                  type="date"
                  size="mini"
                  format="yyyy 年 MM 月 dd 日"
                  placeholder="任务结束时间"
                  style="width: 45%;float: left;display: inline-block"
              >
                <!--value-format="yyyy-MM-dd"-->
              </el-date-picker>
            </el-form-item>
            <el-form-item label="任务状态">
              <el-select v-model="param.state" filterable placeholder="请选择...">
                <el-option label="不限" :value="0"></el-option>
                <el-option label="活动中" :value="1"></el-option>
                <el-option label="已结束" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="促销员姓名" prop="idCard" >
              <el-input v-model="param.salesManName" placeholder="请输入姓名..." :maxlength="10"></el-input>
            </el-form-item>
            <el-form-item label="身份证" prop="idCard" >
              <el-input v-model="param.idCard" placeholder="请输入身份证..." :maxlength="18"></el-input>
            </el-form-item>


          </div>
          
          <hr style="margin-bottom: 9px;">
          <div class="slide-btns clearfix">
            <el-form-item>
              <el-button type="text" class="reset-btn" @click="resetForm()">清空</el-button>
              <el-button class="search-btn" @click="submitForm()">筛选</el-button>
            </el-form-item>
            <div class="floatr">
              <el-form-item>
                <el-button type="text" class="slide-btn" @click="toggleSlide('slideWrap1', $event)">展开筛选项</el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    
    <el-row class="common-box" style="margin-top: 20px;">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">筛选结果</h2>
        <el-button type="primary" size="mini" round @click="getExcel">
          导出表格 <i class="el-icon-download"></i>
        </el-button>
      </div>
      <div class="common-box-body">
        <el-table ref="multipleTable"
                  :data="tableData"
                  size="small"
                  v-loading="listLoading"
                  element-loading-text="拼命加载中"
                  border
                  tooltip-effect="dark"
                  style="width: 100%"
                  header-row-class-name="table-header">
          <!--<el-table-column type="selection" width="50" align="center" fixed></el-table-column>-->
          <el-table-column type="projectNo" label="任务编号" width="100" align="center" fixed="left"></el-table-column>
          <el-table-column prop="projectName" label="任务名称" min-width="300" align="center"></el-table-column>
          <el-table-column prop="salesmanName" label="姓名" min-width="90" align="center" :formatter = "formatName"></el-table-column>
          <el-table-column prop="idcard" label="身份证号" min-width="135" align="center" :formatter = "formatIdCard"></el-table-column>
          <el-table-column prop="" label="开始时间" min-width="80" align="center"></el-table-column>
          <el-table-column prop="" label="结束时间" min-width="80" align="center"></el-table-column>
          <el-table-column prop="" label="任务提交时间" min-width="100" align="center"></el-table-column>
          <el-table-column prop="" label="任务状态" min-width="80" align="center"></el-table-column>
          <el-table-column prop="" label="操作" min-width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button @click="taskDetail(scope.row)" type="text" size="small">任务详情</el-button>
              |
              <el-button @click="pass(scope.row)" type="text" size="small">审核通过</el-button>
              |
              <el-button @click="notPass(scope.row)" type="text" size="small">审核不通过</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <el-pagination class="pagination table-pagination"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="param.pageNo"
                       :page-sizes="[10, 20, 30, 40]"
                       :page-size="param.pageSize"
                       layout="slot, total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </el-row>
  
  </div>
</template>

<script>
  import SalespersonInfo from 'components/salespersonInfo'
  import utils from '../../../common/js/util.js'
  import rules from '../../../common/js/formRules'
  export default {
    name: "task-audit",
    components: {
      SalespersonInfo
    },
    data() {
      return {
        //筛选项参数
        param: {
          taskNo: '', //任务编号
          taskName: '', //任务名称
          idCard: '', //身份证号
          state:'',//任务状态
          salesManName:'',//促销员姓名
          during:{//任务参与时间
            start:'',
            end:"",
          },
          pageNo:1,//数据页码总数信息
          pageSize:10,//当前页展示的信息条数
        },
        starLevelList:[],//获取到的星级列表
        signIdLst:[],//存储tag组件返回的选择的品类
        provinceList:[],//存储省-列表数据
        cityList:[],//存储获取到城市列表
        tableData:[],//展示的表格数据
        isAdmin:false,//是否是超级管理员进入
        total:null,//总数
        uploadDialog:false,//是否展示上传对话框
        listLoading:false,//列表的loading
        loading:false,//全局loading
        rules:{idCard: rules.idcard,}//表单校验规则
      }
    },
    mounted () {
      //获取省市列表数据
      this.searchProvince();
      //判断是否是超级管理员
      //这里好像用不到
      let x = sessionStorage.getItem('user')
      this.isAdmin =  Boolean(x == 'admin1' || x == 'tinashi');
      //获取数据
      this.getData();
    },
    methods: {
      //展开收起
      toggleSlide(slideWrap, event) {
        if (this.$refs[slideWrap].offsetHeight == 42) {
          this.$refs[slideWrap].style.height = "auto";
          event.target.innerHTML = "收起筛选项";
        } else {
          this.$refs[slideWrap].style.height = "42px";
          event.target.innerHTML = "展开筛选项";
        }
      },
      //搜索省市
      searchProvince(id) {
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 1,
            regionId: id
          }
        }).then(res => {
          this.provinceList = res.data;
        }).catch(err => {
          let errMsg;
          if(err.response.message){
            errMsg = err.response.message
          }else{
            errMsg = '查询省市数据失败，请稍后重试'
          }
          this.$notify({
            title: '错误',
            message: errMsg,
            type: 'warning'
          })
        })
      },

      //清空筛选项
      resetForm(){
        this.param.projectNo = null;
        this.param.projectName = null;
        this.param.brand = null;
        this.param.province = '';
        this.param.city = '';
        this.param.idCard = null;
        this.param.rank = '';
      },
      //提交表单（筛选功能）
      submitForm() {
        //是否要加上是否是市辖区的逻辑？如果是则city为市辖区
        this.getData();
      },
      //获取筛选数据
      getData(){
        this.listLoading = true;
        //获取table数据
        this.$http({
          method: "get",
          url: "/rest/BaoJieCr/searchBaoJieCr",
          params: this.param
        }).then(res =>{
          this.tableData = res.data;
          this.listLoading = false;
        }).catch(err => {
          let errMsg;
          if(err.response.message){
            errMsg = err.response.message
          }else{
            errMsg = '查询失败，请稍后重试'
          }
          this.$notify({
            title: '错误',
            message: errMsg,
            type: 'warning'
          })
          this.listLoading = false;
        })
        //获取页码数据
        this.$http({
          method: "get",
          url: "/rest/BaoJieCr/searchBaoJieCrSize",
          params: this.param
        }).then(res =>{
          this.total = res.data;
        }).catch(err => {
          let errMsg;
          if(err.response.message){
            errMsg = err.response.message
          }else{
            errMsg = '查询失败，请稍后重试'
          }
          this.$notify({
            title: '错误',
            message: errMsg,
            type: 'warning'
          })
        })
      },
      //获取城市列表
      searchCity() {
        let id = null ;
        this.param.cityId = null;
        this.provinceList.map(item =>{
          if(this.param.province == item.adName){
            id = item.id;
          }
        })
        if(id != null){
          this.$http({
            method: "POST",
            url: "/rest/salesman/getRegion",
            params: {
              deep: 2,
              regionId: id
            }
          }).then(res => {
            this.cityList = res.data;
          }).catch(err => {
            let errMsg;
            if(err.response.message){
              errMsg = err.response.message
            }else{
              errMsg = '查询失败，请稍后重试'
            }
            this.$notify({
              title: '错误',
              message: errMsg,
              type: 'warning'
            })
          });
        }
      },
      //对于非超级管理员，需要把数据加密
      //身份证加密
      formatIdCard(row, column, cellValue){
        if(this.isAdmin){
          return cellValue
        } else {
          if(cellValue.length == 15){
            return utils.plusXing(cellValue,7,4)
          }else if(cellValue.length == 18){
            return utils.plusXing(cellValue,6,4)
          }else{
            console.log('身份证位数不对',cellValue)
          }
        }
      },
      //姓名加密
      formatName(row, column, cellValue){
        if(cellValue){
          if(this.isAdmin){
            return cellValue
          } else {
            return utils.plusXing(cellValue,1,1)
          }
        }
      },
      //数字转百分比
      formatPercent(row, column, cellValue){
        let x = 0
        if(cellValue != 0){
          x = parseFloat((cellValue*100).toFixed(2))+'%'
        }
        return x
      },
      //每页的显示条目改变时
      handleSizeChange(val) {
        this.param.pageSize = val;
        this.getData();
      },
      //手动选择页码时
      handleCurrentChange(val) {
        this.param.pageNo = val;
        this.getData();
      },
      //导出表格
      getExcel(){
        this.loading = true;//进入全局loading
        this.$http({
          method: "GET",
          url: "/rest/BaoJieCr/downLoadBaoJieCr",
          params:this.param
        }).then(res => {
          this.loading = false;
          location.href = utils.returnUrlHead() + res.data.message;
        }).catch( err => {
          let errMsg;
          if (err.response.message) {
            errMsg = err.response.message
          } else {
            errMsg = '下载失败，请稍后重试'
          }
          this.$notify({
            title: '失败',
            message: errMsg,
            type: 'error'
          })
          this.loading = false;
        })
      },
      //任务详情
      taskDetail(row){
        alert('任务详情')
        console.log(row)
      },
      //审核通过
      pass(row){
        alert('审核通过')
      },
      //审核不通过
      notPass(row){
        alert('审核不通过')
      },
    }
  }
</script>

<style lang="scss" scoped>
  // 查看大图
  .dialog{
    .dialogImage{
      // padding: 20px;
      min-height: 300px;
      background-repeat: no-repeat;
      background-size: 100% !important;
      background-position: center !important;
      img{
        width:100%;
        height:100%;
        opacity: 0;
      }
    }
  }
  .tableImg{
    width:50px;
    height:30px;
    margin: 0 auto;
    img{
      opacity: 0
    }
  }
  .dialogImg{
    width:360px;
    height:230px;
    img{
      opacity: 0
    }
  }
  .bankImg{
    width:360px;
    height:230px;
    img{
      opacity: 0
    }
  }
  .blacklistDialog{
    .dialog-body{
      .reason{
        background: #f4f4f4;
        box-sizing: border-box;
        width: 100%;
        border-radius: 5px;
        textarea{
          background: #f4f4f4;
        }
      }
    }
  }
  .cardDialog{
    .card-img{
      p{
        line-height: 32px;
        color: #666;
      }
      img{
        width: 360px;
        height: 230px;
      }
    }
  }

</style>
<style lang="scss">
  .blacklistDialog .el-textarea__inner{
    border: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/taskCenter/taskAudit/taskAudit.vue